import {
    Route,
    Redirect,
    matchPath,
    useLocation,
  } from "react-router-dom";

  import React from 'react'
  import { PrivateRoute } from "../utils";
  import Header from "./../components/User/Header"
import Home from "../components/User/Home/Catalogue";
import Profile from "../components/User/Profile/ProfilePage";
import PaymentMethod from "../components/User/PaymentMethod";
import Orders from "../components/User/Orders";
import OrderDetail from "../components/User/Orders/OrderDetail";
import OrderInvoice from "../components/User/Orders/OrderInvoice";
import Checkout from "../components/User/Checkout/Recap/CheckoutEntry";
import PickupSlot from "../components/User/Checkout/Slots/PickupSlot";
import DeliverySlot from "../components/User/Checkout/Slots/DeliverySlot";
import { connect } from "react-redux";
import Manager from "../components/Manager";
import Halo from "../components/User/Halo";
import {
  ManagerRoute,
  MANAGER_ROOT,
  isManager,
  isManagerPath,
} from "../utils/managerRouting";

/**
 * Pages client servies ici (`exact` sauf les préfixes). App.js envoie ici
 * toute URL inconnue (« / » sans exact) : sans cette liste, elle affichait
 * la barre du haut sur une page vide.
 */
const CLIENT_PATHS = [
  { path: "/", exact: true },
  { path: "/profile" },
  { path: "/paymentMethod" },
  { path: "/company-manager" },
  { path: "/orders", exact: true },
  { path: "/orders/:id", exact: true },
  { path: "/orders/:id/invoice", exact: true },
  { path: "/order", exact: true },
  { path: "/home", exact: true },
  { path: "/checkout", exact: true },
  { path: "/checkout/pickup", exact: true },
  { path: "/checkout/delivery", exact: true },
];

const isKnownPath = (pathname) =>
  CLIENT_PATHS.some((route) => matchPath(pathname, route));

   const WhiteListRoutes = (props) => {
    const user_uid = props?.isAuthenticated ? true : false;
    const location = useLocation();
    const inManagerArea = isManagerPath(location.pathname);
    const manager = isManager(props.user);

    /**
     * Le rôle CP manager est administratif : un manager authentifié qui atteint
     * une route client est ramené dans son espace. C'est le pendant de
     * `ManagerRoute`, qui protège l'espace dans l'autre sens.
     */
    if (!inManagerArea && !isKnownPath(location.pathname)) {
      return <Redirect to={user_uid ? "/home" : "/sign-in"} />;
    }

    if (user_uid && manager && !inManagerArea) {
      return <Redirect to={MANAGER_ROOT} />;
    }

    /* L'espace manager a son propre fond ; les pages client sont sur le halo. */
    const Root = inManagerArea ? React.Fragment : Halo;

    return (
      <Root>
        {inManagerArea ? null : <Header isNav={true} />}

        <ManagerRoute
          path={MANAGER_ROOT}
          component={Manager}
          authed={user_uid}
          user={props.user}
        />
        {/* Ancienne route conservée le temps que les liens existants s'éteignent. */}
        <Route
          path="/company-manager"
          render={() => <Redirect to={MANAGER_ROOT} />}
        />

        <PrivateRoute exact path="/" component={Home} authed={user_uid} />
        <PrivateRoute authed={user_uid} path="/profile" component={Profile} />
        <PrivateRoute
          authed={user_uid}
          path="/paymentMethod"
          component={PaymentMethod}
        />
        <PrivateRoute authed={user_uid} path="/orders" exact component={Orders} />
        <PrivateRoute authed={user_uid} path="/orders/:id" exact component={OrderDetail} />
        <PrivateRoute authed={user_uid} path="/orders/:id/invoice" exact component={OrderInvoice} />
        {/* Ancienne adresse de la page commandes : les liens existants y
            mènent encore, et « pastOrder » y ouvrait l'onglet Passées. */}
        <Route
          path="/order"
          exact
          render={({ location }) => (
            <Redirect to={location?.state?.pastOrder ? "/orders?tab=past" : "/orders"} />
          )}
        />
        <PrivateRoute authed={user_uid} path="/home" exact component={Home} />
        {/* Pas de Switch dans ce fichier : sans `exact`, /checkout
            s'afficherait aussi sous /checkout/pickup et /checkout/delivery. */}
        <PrivateRoute authed={user_uid} path="/checkout" exact component={Checkout} />
        <PrivateRoute authed={user_uid} path="/checkout/pickup" exact component={PickupSlot} />
        <PrivateRoute authed={user_uid} path="/checkout/delivery" exact component={DeliverySlot} />
      </Root>
    )
  }

  const mapStateToProps = (state) => ({
    isAuthenticated: state?.auth?.isAuthenticated,
    user: state?.auth?.user,
    newUser: state?.auth?.user,
    hAddress: state?.auth?.homeAddress,
    oAddress: state?.auth?.officeAddress,
  });

  export default connect(mapStateToProps)(WhiteListRoutes)
